import { Injectable } from "@angular/core";
import { IApiBaseActions, IQueryParameters, ParamsType } from "../models/api-base-actions.interface";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { SERVER_401, SERVER_403, SERVER_404, SERVER_ERROR } from "../constants/response.constant";
import { tap } from "rxjs/internal/operators/tap";
import { environment } from "../../environments/environment";
import { Observable } from "rxjs/internal/Observable";



@Injectable({
  providedIn: 'root'
})
export class ApiHandlerService implements IApiBaseActions {
  public token: string | null = null;
  apiUrl = environment.dataliveApiUrl;
  constructor(public httpClient: HttpClient) {
  }

  Get<T>(url: string, params?: IQueryParameters): Observable<T> {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8', 'Authorization': 'Bearer  ' + this.token });
    return this.httpClient
      .get<T>(url, { params: this.createParams(params), headers: headers })
      .pipe(tap((x) => this.HandleResponse(x)));
  }


  GetAll<T>(url: string, params?: IQueryParameters): Observable<T> {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8', 'Authorization': 'Bearer  ' + this.token });
    return this.httpClient
      .get<T>(url, { params: this.createParams(params), headers: headers })
      .pipe(tap((x) => this.HandleResponse(x)));
  }

  Post<T>(url: string, data: any, params?: IQueryParameters): Observable<T> {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8', 'Authorization': 'Bearer  ' + this.token });
    return this.httpClient
      .post<T>(url, data, { params: this.createParams(params), headers })
      .pipe(tap((x) => this.HandleResponse(x)));
  }

  Delete(url: string, data: any, params?: IQueryParameters) {
    return this.httpClient
      .delete(url, { params: this.createParams(params) })
      .pipe(tap((x) => this.HandleResponse(x)));
  }

  Put(url: string, data: any, params?: IQueryParameters) {
    return this.httpClient
      .put(url, data, { params: this.createParams(params) })
      .pipe(tap((x) => this.HandleResponse(x)));
  }

  HandleResponse(response: any) {
    switch (response.Status) {
      case 500:
        alert(SERVER_ERROR);
        break;
      case 404:
        alert(SERVER_404);
        break;
      case 403:
        alert(SERVER_403);
        break;
      case 401:
        alert(SERVER_401);
        break;
      default:
        break;
    }
  }

  createParams(params?: IQueryParameters) {
    let httpParams = new HttpParams();
    if (params) {
      Object.entries(params).forEach(([key, value]) => {
        httpParams = httpParams.append(key, value);
      });
    }
    return httpParams;
  }
}
